import { PopUpStore } from "../../Common/_stores/PopUpStore";

export const DevPopUpActions = {
    show: PopUpStore.actionShow,
};